<template>
  <div class="about rt60">
    <div>
      <!-- <banner :child-data="fdata"></banner> -->
      <div style="height:650px;overflow:hidden"
           :style="{ height: Mobile + 'px'}">
        <img v-if="!showMobile"
             src="img/about/关于我们.jpg"
             alt=""
             class="mobile"
             style="height:100%;position: relative;"
             :style="{ height: Mobile + 'px'}">
        <img v-if="showMobile"
             src="img/about/Amobile.jpg"
             alt=""
             class="mobile"
             style="position: relative;"
             :style="{ height: Mobile + 'px'}">
      </div>
      <div id="about-main">
        <div class>
          <div class="company-info container">
            <div class="develop-title">
              <span class="line"></span>
              <span class="title-text mb16">{{$t(h1)}}</span>
              <span class="line"></span>
            </div>
            <div class="develop-desc sepcial">
              <span class="line"></span>
              <span class="title-text lh30">{{$t('aboutUsP0')}}</span>
              <br>
              <span class="title-text lh30">{{$t('aboutUsP1')}}</span>
              <br>
              <span class="title-text lh30">{{$t('aboutUsP2')}}</span>
              <br>
              <!-- <span class="title-text lh30">{{$t(h3)}}</span> -->
              <span class="line"></span>
            </div>
          </div>

          <div class="company-develop">
            <div class="develop-title">
              <span class="line"></span>
              <span class="title-text mb16">{{$t('AboutMission')}}</span>
              <span class="line"></span>
            </div>
            <div class="develop-desc container">
              <b-row class="special">
                <b-col cols="12"
                       sm="12"
                       md="4"
                       lg="4">
                  <img class="img img-circle"
                       src="img/about/mission.png"
                       height="120px"
                       width="120px"
                       alt>
                  <li>{{$t('AboutMissT')}}</li>
                </b-col>
                <b-col cols="12"
                       sm="12"
                       md="4"
                       lg="4">
                  <img class="img img-circle"
                       src="img/about/values.png"
                       height="120px"
                       width="120px"
                       alt>
                  <li>{{$t('AboutMiss1T')}}</li>
                </b-col>
                <b-col cols="12"
                       sm="12"
                       md="4"
                       lg="4">
                  <img class="img img-circle"
                       src="img/about/vision.png"
                       height="120px"
                       width="120px"
                       alt>
                  <li>{{$t('AboutMiss2T')}}</li>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
      </div>

      <div id="team"
           name="team">
        <div class="container">
          <div class="row centered">
            <h2 class="centered mb16">{{$t('Meet Our Team')}}</h2>
            <div class="col-lg-12 centered"
                 data-toggle="modal"
                 data-target="#myModal">
              <!-- <img
                class="img img-circle"
                src="img/about/cooper.png"
                height="120px"
                width="120px"
                alt
              >-->
              <div class="row"
                   style="display:flex;align-items:center;margin-bottom:24px">
                <div class="col-lg-3 centered">
                  <img class="img img-circle"
                       src="img/about/商务男士.png"
                       height="80px"
                       width="80px"
                       alt>
                  <h4 class="mb16x">Cooper Yuan</h4>
                </div>
                <div class="col-lg-9 centered">
                  <p>{{$t('CEO, Cooper is responsible for Neucore’s vision and overall market strategy and execution.')}}</p>
                </div>
              </div>

            </div>
            <div class="col-lg-12 centered"
                 data-toggle="modal"
                 data-target="#myModal">
              <!-- <img
                class="img img-circle"
                src="img/about/robot.JPG"
                height="120px"
                width="120px"
                alt
              >-->
              <div class="row"
                   style="display:flex;align-items:center;margin-bottom:24px">
                <div class="col-lg-3 centered">
                  <img class="img img-circle"
                       src="img/about/商务男士.png"
                       height="80px"
                       width="80px"
                       alt>
                  <h4 class="mb16x">Robot Chen</h4>
                </div>
                <div class="col-lg-9 centered">
                  <p>{{$t('VP, Robot is leading artificial intelligence research, collaboration and implementation.')}}</p>
                </div>
              </div>
            </div>
            <div class="col-lg-12 centered"
                 data-toggle="modal"
                 data-target="#myModal">
              <!-- <img
                class="img img-circle"
                src="img/team/team03.jpg"
                height="120px"
                width="120px"
                alt
              >-->
              <div class="row"
                   style="display:flex;align-items:center;margin-bottom:24px">
                <div class="col-lg-3 centered">
                  <img class="img img-circle"
                       src="img/about/男士.png"
                       height="80px"
                       width="80px"
                       alt>
                  <h4 class="mb16x">Wayne Wu</h4>
                </div>
                <div class="col-lg-9 centered">
                  <p>{{$t('VP, Wayne is in charge of the NeuOS system architecture and embedded software development.')}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="join-main"
           class="bgrow"
           data-ani>
        <div class="container">
          <h2 class="centered pb30">{{$t('Join Us')}}</h2>
          <div class="row">
            <div id="about-main"
                 class="bgrow"
                 data-ani>
              <div class="container">
                <div class="panel-group"
                     id="accordion"
                     role="tablist"
                     aria-multiselectable="true">
                  <b-card no-body
                          class="mb-1">
                    <b-card-header header-tag="header"
                                   class="p-1"
                                   role="tab">
                      <b-button block
                                href="#"
                                v-b-toggle.accordion-1>
                        <div class="panel-heading clearfix"
                             role="tab"
                             id="headingOne">
                          <div class="headingOne_left pull-left">
                            <h4 class="panel-title">{{$t('SocialH0')}}</h4>
                            <p>
                              <span>{{$t('SocialP0')}}</span>
                            </p>
                          </div>
                          <div class="headingOne_right pull-right">
                            <a role="button"
                               data-toggle="collapse"
                               data-parent="#accordion"
                               href="#collapseOne"
                               aria-expanded="true"
                               aria-controls="collapseOne">
                              <span class="glyphicon glyphicon-chevron-down"></span>
                            </a>
                          </div>
                        </div>
                      </b-button>
                    </b-card-header>
                    <b-collapse id="accordion-1"
                                accordion="my-accordion"
                                role="tabpanel">
                      <b-card-body>
                        <div class="panel-body specialPanel">
                          <h3>{{$t('SocialSecH0')}}</h3>
                          <p>{{$t('SocialSecP10')}}</p>
                          <p>{{$t('SocialSecP0')}}</p>
                          <p>{{$t('SocialSecP01')}}</p>
                          <h3>{{$t('SocialSecH01')}}</h3>
                          <p>{{$t('SocialSecP010')}}</p>
                          <p>{{$t('SocialSecP011')}}</p>
                          <p>{{$t('SocialSecP012')}}</p>
                          <a href="mailto:recruitment@neucore.com">
                            <h3 class="email">{{$t('SocialSecEmail')}}</h3>
                          </a>
                        </div>
                      </b-card-body>
                    </b-collapse>
                  </b-card>

                  <b-card no-body
                          class="mb-1"
                          data-ani>
                    <b-card-header header-tag="header"
                                   class="p-1"
                                   role="tab">
                      <b-button block
                                href="#"
                                v-b-toggle.accordion-2>
                        <div role="tab"
                             id="headingOne"
                             class="panel-heading clearfix">
                          <div class="headingOne_left pull-left">
                            <h4 class="panel-title">{{$t('SocialH1')}}</h4>
                            <p>
                              <span>{{$t('SocialP1')}}</span>
                            </p>
                          </div>
                          <div class="headingOne_right pull-right">
                            <a role="button"
                               data-toggle="collapse"
                               data-parent="#accordion"
                               href="#collapseOne1"
                               aria-expanded="true"
                               aria-controls="collapseOne">
                              <span class="glyphicon glyphicon-chevron-down"></span>
                            </a>
                          </div>
                        </div>
                      </b-button>
                    </b-card-header>
                    <b-collapse id="accordion-2"
                                accordion="my-accordion"
                                role="tabpanel">
                      <b-card-body>
                        <div class="panel-body specialPanel">
                          <h3>{{$t('SocialSecH10')}}</h3>
                          <p>{{$t('SocialSecP10')}}</p>
                          <p>{{$t('SocialSecP11')}}</p>
                          <p>{{$t('SocialSecP12')}}</p>
                          <h3>{{$t('SocialSecH11')}}</h3>
                          <p>{{$t('SocialSecP110')}}</p>
                          <p>{{$t('SocialSecP111')}}</p>
                          <p>{{$t('SocialSecP112')}}</p>
                          <p>{{$t('SocialSecP113')}}</p>
                          <p>{{$t('SocialSecP114')}}</p>
                          <p>{{$t('SocialSecP115')}}</p>
                          <a href="mailto:recruitment@neucore.com">
                            <h3 class="email">{{$t('SocialSecEmail')}}</h3>
                          </a>
                        </div>
                      </b-card-body>
                    </b-collapse>
                  </b-card>

                  <b-card no-body
                          class="mb-1">
                    <b-card-header header-tag="header"
                                   class="p-1"
                                   role="tab">
                      <b-button block
                                href="#"
                                v-b-toggle.accordion-3>
                        <div role="tab"
                             id="headingOne"
                             class="panel-heading clearfix">
                          <div class="headingOne_left pull-left">
                            <h4 class="panel-title">{{$t('SocialH2')}}</h4>
                            <p>
                              <span>{{$t('SocialP2')}}</span>
                            </p>
                          </div>
                          <div class="headingOne_right pull-right">
                            <a role="button"
                               data-toggle="collapse"
                               data-parent="#accordion"
                               href="#collapseOne2"
                               aria-expanded="true"
                               aria-controls="collapseOne">
                              <span class="glyphicon glyphicon-chevron-down"></span>
                            </a>
                          </div>
                        </div>
                      </b-button>
                    </b-card-header>
                    <b-collapse id="accordion-3"
                                accordion="my-accordion"
                                role="tabpanel">
                      <b-card-body>
                        <div class="panel-body specialPanel">
                          <h3>{{$t('SocialSecH20')}}</h3>
                          <p>{{$t('SocialSecP20')}}</p>
                          <p>{{$t('SocialSecP21')}}</p>
                          <p>{{$t('SocialSecP22')}}</p>
                          <h3>{{$t('SocialSecH21')}}</h3>
                          <p>{{$t('SocialSecP210')}}</p>
                          <p>{{$t('SocialSecP211')}}</p>
                          <p>{{$t('SocialSecP212')}}</p>
                          <p>{{$t('SocialSecP213')}}</p>
                          <p>{{$t('SocialSecP214')}}</p>
                          <p>{{$t('SocialSecP215')}}</p>
                          <p>{{$t('SocialSecP216')}}</p>
                          <p>{{$t('SocialSecP217')}}</p>
                          <p>{{$t('SocialSecP218')}}</p>
                          <a href="mailto:recruitment@neucore.com">
                            <h3 class="email">{{$t('SocialSecEmail')}}</h3>
                          </a>
                        </div>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import topNav from '../components/top'
import banner from '../components/banner'
import footerBot from '../components/footerBot'
import { mapMutations } from 'vuex'
export default {
  name: 'about',
  data() {
    return {
      screenWidth: document.body.clientWidth,
      showMobile: false,
      Mobile: 650,
      h1: 'Who is Neucore?',
      h3: 'chinesextra',
      h2:
        'Neucore Intelligence is a very creative, dynamic and young Artificial Intelligence company focused on computer vision and deep learning. We were founded in May, 2018 and located in Shanghai city, China. With the mission of making the AI on device for everyone and in everywhere, we are committed to developing innovative Artificial Intelligent solution to meet the requirements of every customer. Our solutions can be used in smart security, smart retail, smart home, automobile, smart factory, and so forth.',
      fdata: {
        h1: '',
        style: {
          background: 'url(../img/join_us/1.jpg) no-repeat center top'
        }
      }
    }
  },
  components: {
    topNav,
    banner,
    footerBot
  },
  methods: {
    ...mapMutations(['editMenu'])
  },
  mounted() {
    if (this.screenWidth < 480 || this.screenWidth === 480) {
      this.showMobile = true
      this.Mobile = window.screen.height
    }
    this.editMenu('about')
  }
}
</script>

<style scoped>
#join-main {
  padding-bottom: 64px;
  padding-top: 64px;
}
#headerwrap {
  background-size: 100% 100% !important;
}
#headerwrap h2 {
  font-size: 20px;
  text-align: left;
}
.pb30 {
  padding-bottom: 30px;
}
blockquote {
  border: none;
}
#navbar-main {
  /* height: 144px; */
}
#about-main {
  /* padding-bottom: 30px; */
  width: 100%;
}
#headerwrap {
  /* background: url(../../public/img/about/gyks_banner@3x.jpg) no-repeat center top; */
  display: flex;
  align-items: center;
  justify-content: center;
}
#headerwrap h1 {
  margin-top: 0;
}

#headerwrap h2 {
  color: white;
  margin-bottom: 0;
}

#about-main .img-banner {
  height: 380px;
  width: 100%;
  /* background: url(img/about/gyks_banner@3x.jpg) no-repeat 100% center; */
  background-size: 100% 100%;
  box-sizing: border-box;
}

#about-main .img-banner h3 {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 40px;
}

@media screen and (max-width: 480px) {
  #about-main .img-banner {
    height: 170px;
    width: 100%;
    background: url(../../public/img/about/gyks_banner@3x.jpg) no-repeat center;
    background-size: 100% 100%;
  }
}
#about-main .company-info {
  /* padding: 20px 0px; */
  box-sizing: border-box;
  padding: 64px 15px;
  text-align: left;
}
.company-develop {
  padding-top: 64px;
  padding-bottom: 64px;
  background: rgb(245, 245, 245);
}
#about-main .info-title,
#about-main .develop-title {
  font-size: 34px;
  line-height: 44px;
  text-align: center;
  color: rgb(44, 62, 80);
}
#about-main .info-main {
  display: flex;
  flex-direction: column;
  /* align-items: ; */
}
#about-main .info-title .title-text,
#about-main .develop-title .title-text {
  font-size: 34px;
  line-height: 44px;
  text-align: center;
  color: rgb(44, 62, 80);
}

.tab-content {
  background-color: #fff;
  border: 1px solid #ddd;
  border-top: 0;
  padding: 15px 15px 5px;
  box-sizing: border-box;
}

.progress {
  box-shadow: none;
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0.06);
}

.progress .progress-bar {
  box-shadow: none;
  background-color: #32b9b1;
}

.progress .progress-bar-success {
  background-color: #51be38;
}

.progress .progress-bar-info {
  background-color: #5bc0de;
}

.progress .progress-bar-warning {
  background-color: #ef9544;
}

.progress .progress-bar-danger {
  background-color: #f05a5b;
}

.well {
  box-shadow: none;
  background-color: rgba(0, 0, 0, 0.05);
}

#headerwrap p {
  font-weight: 300;
  text-align: center;
  letter-spacing: 1px;
}

#team {
  /* background: url(img/bg.4b71ff6e.png) no-repeat center center fixed; */
  padding: 64px 0;
  text-align: center;
  background-size: cover;
  color: black;
}
#team p {
  text-align: left;
}
#team hr {
  display: block;
  height: 3px;
  border: 0;
  margin: 3em 0;
  padding: 0;
  background-image: -webkit-linear-gradient(
    left,
    rgba(255, 255, 255, 0),
    #71c9d6,
    rgba(255, 255, 255, 0)
  );
  background-image: -moz-linear-gradient(
    left,
    rgba(255, 255, 255, 0),
    #71c9d6,
    rgba(255, 255, 255, 0)
  );
  background-image: -ms-linear-gradient(
    left,
    rgba(255, 255, 255, 0),
    #71c9d6,
    rgba(255, 255, 255, 0)
  );
  background-image: -o-linear-gradient(
    left,
    rgba(255, 255, 255, 0),
    #71c9d6,
    rgba(255, 255, 255, 0)
  );
  position: relative;
  border: none;
  background-image: -webkit-linear-gradient(left, #fff, #e6e6e6, #fff);
  height: 2px;
  width: 100%;
}

#team h2 {
  font-size: 34px;
  line-height: 44px;
  text-align: center;
  color: rgb(44, 62, 80);
  width: 100%;
}

#team p {
  color: rgb(44, 62, 80);
}

#team h4 {
  padding-top: 10px;
  color: rgb(44, 62, 80);
  font-weight: bold;
}

#team p.large {
  margin-top: 60px;
  margin-bottom: 30px;
}

#team .fa {
  width: 30px;
  height: 30px;
  margin: 0 3px;
  border-radius: 100%;
  font-size: 15px;
  line-height: 30px;
  outline: 0;
  color: #fff;
  background-color: #67c5d3;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  transition: all 0.3s;
}

#team .fa:hover {
  background-color: #2ea0b1;
}

.timeline {
  list-style: none;
  position: relative;
  max-width: 1200px;
  padding: 20px 0px;
  margin: 0 auto;
  overflow: hidden;
  box-sizing: border-box;
}

.timeline:after {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -2px;
  background-color: rgba(0, 0, 0, 0.2);
  height: 100%;
  width: 4px;
  border-radius: 2px;
  display: block;
}

.timeline .timeline-row {
  padding-left: 50%;
  position: relative;
  z-index: 10;
  box-sizing: border-box;
}

.timeline .timeline-row .timeline-time {
  position: absolute;
  right: 50%;
  top: 31px;
  text-align: right;
  margin-right: 40px;
  font-size: 16px;
  line-height: 1.3;
  font-weight: 600;
}

.timeline .timeline-row .timeline-time small {
  display: block;
  color: #fff;
  text-transform: uppercase;
  opacity: 0.75;
  font-size: 11px;
  font-weight: 400;
}

.timeline .timeline-row .timeline-icon {
  position: absolute;
  top: 30px;
  left: 50%;
  margin-left: -20px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #fff;
  text-align: center;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  padding: 3px;
  color: #fff;
  font-size: 14px;
  z-index: 100;
  box-sizing: border-box;
}

.timeline .timeline-row .timeline-icon > div {
  border-radius: 50%;
  line-height: 34px;
  font-size: 16px;
}

.timeline .timeline-row .timeline-content {
  margin-left: 40px;
  position: relative;
  background-color: #fff;
  color: #333;
}

.timeline .timeline-row .timeline-content:after {
  content: '';
  position: absolute;
  top: 48px;
  left: -41px;
  height: 4px;
  width: 40px;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: -1;
}

.timeline .timeline-row .timeline-content .panel-body {
  padding: 15px 0px 2px;
  position: relative;
  z-index: 10;
  box-sizing: border-box;
}
.specialPanel {
  padding: 10px;
}
.timeline .timeline-row .timeline-content h2 {
  font-size: 22px;
  margin-bottom: 12px;
  margin-top: 0;
  line-height: 1.2;
}

.timeline .timeline-row .timeline-content p {
  margin-bottom: 15px;
}

.timeline .timeline-row .timeline-content img {
  margin-bottom: 15px;
}

.timeline .timeline-row .timeline-content blockquote {
  border-color: #eee;
}

.timeline .timeline-row .timeline-content blockquote footer,
.timeline .timeline-row .timeline-content blockquote small,
.timeline .timeline-row .timeline-content blockquote .small,
.timeline .timeline-row .timeline-content blockquote.blockquote-reverse footer,
.timeline .timeline-row .timeline-content blockquote.blockquote-reverse small,
.timeline .timeline-row .timeline-content blockquote.blockquote-reverse .small {
  color: #999;
}

.timeline .timeline-row .timeline-content .video-container {
  position: relative;
  padding-bottom: 56.25%;
  padding-top: 30px;
  height: 0;
  margin-bottom: 15px;
  overflow: hidden;
  box-sizing: border-box;
}

.timeline .timeline-row .timeline-content .video-container iframe,
.timeline .timeline-row .timeline-content .video-container object,
.timeline .timeline-row .timeline-content .video-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.timeline .timeline-row:nth-child(odd) {
  padding-left: 0;
  padding-right: 50%;
  box-sizing: border-box;
}

.timeline .timeline-row:nth-child(odd) .timeline-time {
  right: auto;
  left: 50%;
  text-align: left;
  margin-right: 0;
  margin-left: 40px;
}

.timeline .timeline-row:nth-child(odd) .timeline-content {
  margin-right: 40px;
  margin-left: 0;
}

.timeline .timeline-row:nth-child(odd) .timeline-content:after {
  left: auto;
  right: -41px;
}

.timeline.d .timeline-row .timeline-content {
  opacity: 0;
  left: 20px;
  -webkit-transition: all 0.8s;
  -moz-transition: all 0.8s;
  transition: all 0.8s;
}

.timeline.d .timeline-row:nth-child(odd) .timeline-content {
  left: -20px;
}

.timeline.d .timeline-row.active .timeline-content {
  opacity: 1;
  left: 0;
}

.timeline.d .timeline-row.active:nth-child(odd) .timeline-content {
  left: 0;
}

@media (max-width: 1200px) {
  .timeline {
    padding: 15px 10px;
    box-sizing: border-box;
  }

  .timeline:after {
    left: 28px;
  }

  .timeline .timeline-row {
    padding-left: 0;
    margin-bottom: 16px;
    box-sizing: border-box;
  }

  .timeline .timeline-row .timeline-time {
    position: relative;
    right: auto;
    top: 0;
    text-align: left;
    margin: 0 0 6px 56px;
  }

  .timeline .timeline-row .timeline-time strong {
    display: inline-block;
    margin-right: 10px;
  }

  .timeline .timeline-row .timeline-icon {
    top: 52px;
    left: -2px;
    margin-left: 0;
  }

  .timeline .timeline-row .timeline-content {
    margin-left: 56px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    position: relative;
  }

  .timeline .timeline-row .timeline-content:after {
    right: auto !important;
    left: -20px !important;
    top: 32px;
  }

  .timeline .timeline-row:nth-child(odd) {
    padding-right: 0;
    box-sizing: border-box;
  }

  .timeline .timeline-row:nth-child(odd) .timeline-time {
    position: relative;
    right: auto;
    left: auto;
    top: 0;
    text-align: left;
    margin: 0 0 6px 56px;
  }

  .timeline .timeline-row:nth-child(odd) .timeline-content {
    margin-right: 0;
    margin-left: 55px;
  }

  .timeline.d .timeline-row:nth-child(odd) .timeline-content {
    left: 20px;
  }

  .timeline.d .timeline-row.active:nth-child(odd) .timeline-content {
    left: 0;
  }
}

#join-main .img-banner h3 {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 40px;
}

@media screen and (max-width: 480px) {
  #join-main .img-banner {
    height: 170px;
    width: 100%;
    background: url(../../public/img/product/cpzx_banner@3x.jpg) no-repeat
      center;
    background-size: 100% 100%;
  }
  .mobile {
    width: auto !important;
    height: 100% !important;
  }
}

#join-main .company-info {
  padding: 80px 0px;
  box-sizing: border-box;
}

#join-main .info-title,
#join-main .develop-title {
  text-align: center;
  margin-bottom: 30px;
}

#join-main .info-main {
  width: 80%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
}

#join-main .info-main img {
  width: 100%;
}

#join-main .info-title .title-text,
#join-main .develop-title .title-text {
  font-size: 30px;
}

.bgrow {
  background: rgb(245, 245, 245) no-repeat center top;
  background-size: 100%;
}
.box_shadow {
  height: 180px;
  box-shadow: 0 5px 30px 0 rgba(77, 138, 221, 0.15);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 80px 0px;
  padding-bottom: 0;
  background-clip: content-box;
}

.spandf {
  display: flex;
  flex-direction: column;
  line-height: 40px;
  font-size: 20px;
  margin-left: 30px;
}
.spandf span {
  text-align: left;
}
.spandf span:nth-child(1) {
  font-weight: 600;
}

.spandf span:nth-child(2) {
  font-size: 16px;
}
.w20 {
  width: 25%;
}

@font-face {
  font-family: 'Glyphicons Halflings';

  src: url('../../public/fonts/glyphicons-halflings-regular.eot');
  src: url('../../public/fonts/glyphicons-halflings-regular.eot')
      format('embedded-opentype'),
    url('../../public/fonts/glyphicons-halflings-regular.woff') format('woff'),
    url('../../public/fonts/glyphicons-halflings-regular.ttf')
      format('truetype'),
    url('../../public/fonts/glyphicons-halflings-regular.svg#glyphicons_halflingsregular')
      format('svg');
}
.glyphicon {
  position: relative;
  top: 1px;
  display: inline-block;
  font-family: 'Glyphicons Halflings';
  font-style: normal;
  font-weight: normal;
  line-height: 1;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

blockquote {
  border: none;
}

.w20 {
  width: 25%;
}
.panel-default > .panel-heading {
  padding: 20px;
  display: flex;
  align-items: center;
}
.panel-group .panel {
  margin-bottom: 20px;
}
.panel-title {
  font-weight: 600;
  font-size: 20px;
}
.glyphicon.glyphicon-chevron-down {
  font-size: 30px;
}
.headingOne_left p {
  margin: 0;
  margin-top: 12px;
}
.headingOne_right {
  flex: 1;
  text-align: right;
}
#about-main {
  padding-bottom: 30px;
  margin-top: 0px;
}

.company-develop {
  width: 100%;
  margin: 0 auto;
}

.company-develop #myTabs {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
}

.company-develop #myTabs li {
  flex: 1;
  text-align: center;
}

[class^='icon-'],
[class*=' icon-'] {
  font-family: icomoon;
  speak: none;
  font-style: normal;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body,
html {
  font-size: 100%;
  padding: 0;
  margin: 0;
}

*,
*:after,
*:before {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.clearfix:before,
.clearfix:after {
  content: ' ';
  display: table;
}

.clearfix:after {
  clear: both;
}

a {
  color: #2fa0ec;
  text-decoration: none;
  outline: 0;
}

.htmleaf-container {
  margin: 0 auto;
  text-align: center;
  overflow: hidden;
}

.htmleaf-content {
  font-size: 150%;
  padding: 1em 0;
}

.htmleaf-content h2 {
  margin: 0 0 2em;
  opacity: 0.1;
}

.htmleaf-content p {
  margin: 1em 0;
  padding: 5em 0 0;
  font-size: 0.65em;
}

.bgcolor-1 {
  background: #f0efee;
}

.bgcolor-2 {
  background: #f9f9f9;
}

.bgcolor-3 {
  background: #e8e8e8;
}

.bgcolor-4 {
  background: #2f3238;
  color: #fff;
}

.df {
  /* background: white; */
  /* background: beige;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 60px 0px;
    padding-bottom: 0;
    background-clip: content-box; */
}
h3 {
  margin-top: 0;
}
.bgrow {
  background: rgb(245, 245, 245) no-repeat center top;
  background-size: 100%;
}
.col-md-4 {
  padding-bottom: 0;
}
.box_shadow {
  height: 180px;
  box-shadow: 0 5px 30px 0 rgba(77, 138, 221, 0.15);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 80px 0px;
  padding-bottom: 0;
  background-clip: content-box;
}
.spandf {
  display: flex;
  flex-direction: column;
  line-height: 40px;
  font-size: 20px;
  margin-left: 30px;
}
.spandf span:nth-child(1) {
  font-weight: 600;
}
.spandf span:nth-child(2) {
  font-size: 16px;
}
.bgcolor-5 {
  background: #df6659;
  color: #521e18;
}

.bgcolor-6 {
  background: #2fa8ec;
}

.bgcolor-7 {
  background: #d0d6d6;
}

.bgcolor-8 {
  background: #3d4444;
  color: #fff;
}

.bgcolor-9 {
  background: #ef3f52;
  color: #fff;
}

.bgcolor-10 {
  background: #64448f;
  color: #fff;
}

.bgcolor-11 {
  background: #3755ad;
  color: #fff;
}

.bgcolor-12 {
  background: #3498db;
  color: #fff;
}

.htmleaf-header {
  padding: 1em 190px;
  letter-spacing: -1px;
  text-align: center;
}

.htmleaf-header h1 {
  font-weight: 600;
  font-size: 2em;
  line-height: 1;
  margin-bottom: 0;
  font-family: segoe ui, lucida grande, Helvetica, Arial, microsoft yahei,
    FreeSans, Arimo, droid sans, wenquanyi micro hei, hiragino sans gb,
    hiragino sans gb w3, fontawesome, sans-serif;
}

.htmleaf-header h1 span {
  font-family: segoe ui, lucida grande, Helvetica, Arial, microsoft yahei,
    FreeSans, Arimo, droid sans, wenquanyi micro hei, hiragino sans gb,
    hiragino sans gb w3, fontawesome, sans-serif;
  display: block;
  font-size: 60%;
  font-weight: 400;
  padding: 0.8em 0 0.5em;
  color: #c3c8cd;
}

.htmleaf-demo a {
  color: #1d7db1;
  text-decoration: none;
}

.htmleaf-demo {
  width: 100%;
  padding-bottom: 1.2em;
}

.htmleaf-demo a {
  display: inline-block;
  margin: 0.5em;
  padding: 0.6em 1em;
  border: 3px solid #1d7db1;
  font-weight: 700;
}

.htmleaf-demo a:hover {
  opacity: 0.6;
}

.htmleaf-demo a.current {
  background: #1d7db1;
  color: #fff;
}

.htmleaf-links {
  position: relative;
  display: inline-block;
  white-space: nowrap;
  font-size: 1.5em;
  text-align: center;
}

.htmleaf-links::after {
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -1px;
  width: 2px;
  height: 100%;
  background: #dbdbdb;
  content: '';
  -webkit-transform: rotate3d(0, 0, 1, 22.5deg);
  transform: rotate3d(0, 0, 1, 22.5deg);
}

.htmleaf-icon {
  display: inline-block;
  margin: 0.5em;
  padding: 0;
  width: 1.5em;
  text-decoration: none;
}

.htmleaf-icon span {
  display: none;
}

.htmleaf-icon:before {
  margin: 0 5px;
  text-transform: none;
  font-weight: 400;
  font-style: normal;
  font-variant: normal;
  font-family: icomoon;
  line-height: 1;
  speak: none;
  -webkit-font-smoothing: antialiased;
}

.htmleaf-footer {
  width: 100%;
  padding-top: 10px;
}

.htmleaf-small {
  font-size: 0.8em;
}

.center {
  text-align: center;
}

.related {
  color: #fff;
  background: #333;
  text-align: center;
  font-size: 1.25em;
  padding: 0.5em 0;
  overflow: hidden;
}

.related > a {
  vertical-align: top;
  width: calc(100% - 20px);
  max-width: 340px;
  display: inline-block;
  text-align: center;
  margin: 20px 10px;
  padding: 25px;
  font-family: segoe ui, lucida grande, Helvetica, Arial, microsoft yahei,
    FreeSans, Arimo, droid sans, wenquanyi micro hei, hiragino sans gb,
    hiragino sans gb w3, fontawesome, sans-serif;
}

.related a {
  display: inline-block;
  text-align: left;
  margin: 20px auto;
  padding: 10px 20px;
  opacity: 0.8;
  -webkit-transition: opacity 0.3s;
  transition: opacity 0.3s;
  -webkit-backface-visibility: hidden;
}

.related a:hover,
.related a:active {
  opacity: 1;
}

.related a img {
  max-width: 100%;
  opacity: 0.8;
  border-radius: 4px;
}

.related a:hover img,
.related a:active img {
  opacity: 1;
}

.related h3 {
  font-family: microsoft yahei, sans-serif;
}

.related a h3 {
  font-weight: 300;
  margin-top: 0.15em;
  color: #fff;
}

.icon-htmleaf-home-outline:before {
  content: '\e5000';
}

.icon-htmleaf-arrow-forward-outline:before {
  content: '\e5001';
}

@media screen and (max-width: 50em) {
  .htmleaf-header {
    padding: 3em 10% 4em;
  }

  .htmleaf-header h1 {
    font-size: 2em;
  }
}

@media screen and (max-width: 40em) {
  .htmleaf-header h1 {
    font-size: 1.5em;
  }
}

@media screen and (max-width: 30em) {
  .htmleaf-header h1 {
    font-size: 1.2em;
  }
}

.glyphicon-chevron-down:before {
  content: '\e114';
}
.headingOne_left {
  text-align: left;
}
.headingOne_right a:hover {
  color: white;
}
.btn-secondary:hover:hover {
  color: #fff;
  background-color: lightblue;
  border-color: #545b62;
}
.btn-secondary {
  background-color: #f5f5f5;
  border-color: #ddd;
  border: 0;
  color: black;
}
.card-body {
  text-align: left;
}
.develop-desc.special {
  text-align: left;
}
.btn-secondary:not(:disabled):not(.disabled):active,
.btn-secondary:not(:disabled):not(.disabled).active,
.show > .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: lightblue;
  border-color: #545b62;
  border: 0;
}
.btn-secondary:focus,
.btn-secondary.focus {
  color: #fff;
  background-color: lightblue;
  border-color: #545b62;
  border: 0;
}
.special img {
  width: auto;
  height: 100px;
  margin-bottom: 20px;
}
.special li {
  color: #2c3e50;
  font-size: 16px;
  font-weight: 500;
  list-style: none;
}
.mb16 {
  margin-bottom: 3rem;
  display: block;
}
.mb16x {
  margin-bottom: 16px;
}
.lh30 {
  line-height: 30px;
}
.rt60 {
  position: relative;
  top: -60px;
  margin-bottom: -60px;
}
</style>
